import type { SocialAuthTypes } from '@patrianna/shared-patrianna-types/store/AuthModule'
import { googleAuth as googleAuthAction } from '@patrianna/shared-store/auth/store/googleActions'

import { GOOGLE_APP_ID } from 'src/config/apps'
import type { TypedThunk } from 'src/store/types'
import { LS_AUTH_TYPE, setDataToLocalStorage } from 'src/utils/localStorage'

export const googleAuth =
  (authType: SocialAuthTypes): TypedThunk =>
  (dispatch) => {
    dispatch(setDataToLocalStorage(LS_AUTH_TYPE, authType, false))
    dispatch(googleAuthAction({ authType, gId: GOOGLE_APP_ID }))
  }
